require.register("app/seller/show/StatsTab", function(exports, require, module){
  $0
  
});

